import { Paper, SxProps, Theme } from '@mui/material'
import { ReactNode } from 'react'
import ExpirationHeader from './ExpirationHeader'

interface BodyPaperProps {
  children: ReactNode
  showExpiration?: boolean
  showLogoutButton?: boolean
  sx?: SxProps<Theme>
  'data-testid'?: string
}

const BodyPaper = ({
  children,
  showExpiration = false,
  showLogoutButton = false,
  sx,
  'data-testid': dataTestId,
}: BodyPaperProps) => {
  return (
    <>
      {showExpiration ? <ExpirationHeader showLogoutButton={showLogoutButton} /> : null}
      <Paper data-testid={dataTestId} sx={{ padding: 3, minHeight: '60vh', width: '100%', ...sx }}>
        {children}
      </Paper>
    </>
  )
}

export default BodyPaper
